import { post } from 'stores/_services/dataService';

enum LOG_LEVEL {
    error = 'error',
    info = 'info',
    debug = 'debug',
    warn = 'warn'
}

const MIN_LOG_INTERVAL = 3000;

class log {
    lastLog = {
        error: { date: 0, hash: '' },
        debug: { date: 0, hash: '' },
        warn: { date: 0, hash: '' },
        info: { date: 0, hash: '' }
    };

    public error(errorOrMessage: string | Error, err?: Error, additionalData?: any): void {
        let message = errorOrMessage as string;
        let stacktrace = '';

        if (errorOrMessage instanceof Error) {
            message = errorOrMessage.message;
            stacktrace = JSON.stringify(errorOrMessage, Object.getOwnPropertyNames(errorOrMessage));
        } else if (err && typeof err === 'object') {
            stacktrace = JSON.stringify(err, Object.getOwnPropertyNames(err));
        }
        const data = {
            message,
            error: stacktrace,
            ...additionalData
        };

        this._log(LOG_LEVEL.error, message, data);
    }

    public warn(message: string, data: any): void {
        this._log(LOG_LEVEL.warn, message, data);
    }

    public info(message: string, data: any): void {
        this._log(LOG_LEVEL.info, message, data);
    }

    public debug(message: string, data: any): void {
        this._log(LOG_LEVEL.debug, message, data);
    }

    private async _log(level: LOG_LEVEL, message: string, data: any): void {
        const lastLog = this.lastLog[level];
        const hash = message + JSON.stringify(data);

        if (lastLog.hash === hash && Date.now() - lastLog.date < MIN_LOG_INTERVAL) {
            return;
        }

        lastLog.hash = hash;
        lastLog.date = Date.now();

        try {
            await post('logs', {
                level,
                data: {
                    message,
                    ...data
                }
            });
        } catch (e) {
            // TODO: Add retry functionality
        }
    }
}

export default new log();
